import React, { useMemo } from "react";
import Card from "common/Boxes/Card.tsx";
import Row from "antd/es/row";
import Col from "antd/es/col";
import AccountAndExchange from "features/portfolio/Accounts/AccountAndExchange.tsx";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon.tsx";
import {
  DisplayCurrency,
  PrecisionConfig,
  ProcessedCoinExchangesData,
} from "@shared/types";
import { useTheme } from "styled-components";
import { RootState } from "app/store.ts";

interface CoinAccountCardProps {
  item: ProcessedCoinExchangesData;
  columnSpans: number[];
  precisionSelector?: (state: RootState) => PrecisionConfig | {} | undefined;
  displayCurrency: DisplayCurrency;
}

const CoinAccountCard = ({
  item,
  columnSpans,
  precisionSelector,
  displayCurrency,
}: CoinAccountCardProps) => {
  const theme = useTheme();

  const textStyle = useMemo(() => {
    return { color: theme.colors.primaryText };
  }, [theme]);

  return (
    <Card style={CARD_STYLE}>
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col span={columnSpans[0]}>
          <AccountAndExchange
            account={item?.client}
            exchange={item?.exchange}
            style={ACCOUNT_STYLE}
            iconSize="xl"
            ellipsis={true}
            iconStyle={ACCOUNT_ICON_STYLE}
          />
        </Col>
        <Col span={columnSpans[1]}>
          <TextWithPrecisionAndIcon
            precisionSelector={precisionSelector}
            text={item?.total[displayCurrency]}
            round={true}
            style={textStyle}
          />
        </Col>
        <Col span={columnSpans[2]}>
          <TextWithPrecisionAndIcon
            precisionSelector={precisionSelector}
            text={item?.available[displayCurrency]}
            round={true}
            style={textStyle}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(CoinAccountCard);

const CARD_STYLE = { padding: 12 };
const ACCOUNT_ICON_STYLE = { marginRight: 6 };
const ACCOUNT_STYLE = { alignItems: "flex-start", minWidth: 50 };
